import { api } from './client'
import type { WorkPointRef } from './depozite'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Mentenanta/EquipmentModels.cs ----------

export type EquipmentStatus = 'Functional' | 'InMentenanta' | 'Defect' | 'Casat'

export interface EquipmentListItem {
  id: string
  code: string
  name: string
  manufacturer: string | null
  model: string | null
  status: EquipmentStatus
  responsibleUserName: string | null
  isActive: boolean
}

export interface EquipmentDetail {
  id: string
  code: string
  name: string
  manufacturer: string | null
  model: string | null
  serialNumber: string | null
  manufactureYear: number | null
  commissionedAt: string | null
  location: string | null
  nominalCapacity: string | null
  status: EquipmentStatus
  responsibleUserId: string | null
  costCenter: string | null
  workPointId: string
  isActive: boolean
}

export type SaveEquipmentPayload = Omit<EquipmentDetail, 'id' | 'isActive'>

export interface MoldListItem { id: string; code: string; name: string; compatibleEquipmentCount: number; compatibleArticleCount: number; isActive: boolean }

export interface MoldDetail {
  id: string
  code: string
  name: string
  isActive: boolean
  compatibleEquipmentIds: string[]
  compatibleArticleIds: string[]
}

export type SaveMoldPayload = Omit<MoldDetail, 'id' | 'isActive'>

export interface UserRef { id: string; fullName: string }

export const listEquipmentResponsibles = () => api.get<UserRef[]>('/mentenanta/echipamente/responsabili').then((r) => r.data)
export const listEquipmentWorkPoints = () => api.get<WorkPointRef[]>('/mentenanta/echipamente/puncte-lucru').then((r) => r.data)

export const listEquipment = () => api.get<EquipmentListItem[]>('/mentenanta/echipamente/utilaje').then((r) => r.data)
export const getEquipment = (id: string) => api.get<EquipmentDetail>(`/mentenanta/echipamente/utilaje/${id}`).then((r) => r.data)
export const createEquipment = (payload: SaveEquipmentPayload) =>
  api.post<{ id: string }>('/mentenanta/echipamente/utilaje', payload).then((r) => r.data)
export const updateEquipment = (id: string, payload: SaveEquipmentPayload) =>
  api.put(`/mentenanta/echipamente/utilaje/${id}`, payload)
export const deactivateEquipment = (id: string) => api.post(`/mentenanta/echipamente/utilaje/${id}/deactivate`)

export const listMolds = () => api.get<MoldListItem[]>('/mentenanta/echipamente/matrite').then((r) => r.data)
export const getMold = (id: string) => api.get<MoldDetail>(`/mentenanta/echipamente/matrite/${id}`).then((r) => r.data)
export const createMold = (payload: SaveMoldPayload) =>
  api.post<{ id: string }>('/mentenanta/echipamente/matrite', payload).then((r) => r.data)
export const updateMold = (id: string, payload: SaveMoldPayload) =>
  api.put(`/mentenanta/echipamente/matrite/${id}`, payload)
export const deactivateMold = (id: string) => api.post(`/mentenanta/echipamente/matrite/${id}/deactivate`)
